import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { css } from "emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AccountSettingsState } from "../../context/AccountSettingsState";
import GenericButton from "../GenericButton";
import workspaces from "../../services/api/workspaces";
import { GlobalContext } from "../../context/GlobalState";

const WorkspaceSettings = ({ history }) => {
  const data = useContext(AccountSettingsState);
  const { addWorkspace, updateUser } = useContext(GlobalContext);
  const { setCurrentWorkspace } = useContext(AccountSettingsState);
  const [showNewWorkspaceForm, setShowNewWorkspaceForm] = useState(false);
  const [workspaceName, setWorkspaceName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setCurrentWorkspace(newValue);
  };

  const addNewWorkspace = () => {
    setShowNewWorkspaceForm(true);
  };

  const handleNewWorkspaceName = (e) => {
    setWorkspaceName(e.target.value);
  };

  const createWorkspace = async () => {
    setLoading(true);
    const { data: payload } = await workspaces.create({ name: workspaceName });
    const { updatedWorkspace: data, updatedRoles } = payload;
    const formattedWorkspaceData = {
      id: data.id,
      name: data.name,
      stripeCustomerId: data.stripeCustomerId,
      hasBillingCard: data.hasBillingCard,
      currentPlan: data.currentPlan,
    };

    updateUser({ roles: updatedRoles });

    addWorkspace(formattedWorkspaceData);
    history.push("/home");
  };

  return (
    <div className={container}>
      <div className="title">Workspace Settings</div>
      <div className="form">
        <div className="formItem">
          <label>
            <p>WORKSPACE NAME</p>
            <input
              defaultValue={data.currentWorkspace.name}
              onChange={handleChange}
            />
          </label>
        </div>
        <div className="formItem new-workspace">
          {showNewWorkspaceForm ? (
            <div className="add-workspace-form">
              <FontAwesomeIcon icon="plus" color={colors.brandColor} />
              <span>New Workspace</span>
              <div className="formItem">
                <label>NEW WORKSPACE NAME</label>
                <input
                  className="new-workspace-name"
                  name="new-workspace-name"
                  onChange={handleNewWorkspaceName}
                />
                <div className="submit-button-container">
                  <GenericButton
                    text="CREATE WORKSPACE"
                    disabled={workspaceName.length < 1 || loading}
                    handleClick={createWorkspace}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div onClick={addNewWorkspace} className="new-workspace-button">
              <FontAwesomeIcon icon="plus" color={colors.brandColor} />
              <span>New Workspace</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(WorkspaceSettings);

const container = css`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 20px 15px 10px;
  width: 100%;

  .title {
    padding: 0 0 10px 10px;
    width: 100%;
  }

  label {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    padding: 5px 0;

    p {
      padding: 5px 0;
    }
  }
  input {
    background-color: ${colors.inputBackground};
    padding: 10px;
    border: none;
    border-radius: ${boxStyles.borderRadius};
    color: ${colors.inputTextColor};
    font-size: ${textSizes.normal};
    width: 100%;
  }

  .formItem {
    padding: 7px 0;

    span {
      margin-left: 15px;
    }
  }

  .disabled {
    opacity: 0.5;
  }

  .new-workspace {
    padding: 20px 0 10px;
    border-top: 1px solid #efefef;
    margin-top: 10px;

    &-button {
      cursor: pointer;
      transition-duration: 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }

    .submit-button-container {
      margin-top: 30px;
      max-width: 200px;
    }
  }
`;
